import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextTruncate from 'react-text-truncate';
import { scroll } from '../../../shared/navigation/utils';

const Container = styled.div`
  display: flex;
  align-items: end;
  font: ${props => props.theme.fontWeightRegular} 18px/130% ${props => props.theme.fontFamilyBody};
  margin: 0;
  width: 100%;
  ${props => props.theme.isLarge && `
    max-width: 750px;
  `};
  ${props => props.theme.isXLarge && `
    max-width: 610px;
  `};
  color: ${props => props.theme.bodyColor};

  & .more-anchor {
    font-weight: ${props => props.theme.fontWeightBold};

    :hover {
      text-decoration: none;
    }
  }
`;

const scrollToAbout = e => {
  e.preventDefault();
  scroll('about');
};

export default function Blurb({ blurb }) {
  return (
    <Container>
      {!!blurb && (
        <TextTruncate
          line={3}
          element="span"
          truncateText=" …"
          text={blurb}
          textTruncateChild={<a href="#" className="more-anchor" onClick={scrollToAbout}>More</a>}
        />
      )}
    </Container>
  );
}

Blurb.propTypes = { blurb: PropTypes.string };

Blurb.defaultProps = { blurb: null };
